import React from 'react'
import { ViewProps } from 'react-native'
import { A11y, A11yIndexProps } from 'react-native-a11y-order'

type A11yOrderProps = React.ComponentProps<typeof A11y.Order>

export const A11yOrder: React.FC<A11yOrderProps & ViewProps> = (props) => {
  console.log('A11yOrder.web', props)
  return <A11y.Order {...props} />
}

export const A11yIndex: React.FC<A11yIndexProps & ViewProps> = (props) => {
  console.log('A11yIndex.web', props)

  return <A11y.Index {...props} />
}
